const NotFound = () => {
    return <div>Not found</div>
}

export default NotFound